import { render, staticRenderFns } from "./AffiliateQuickSummary.vue?vue&type=template&id=1cf18b1f&"
import script from "./AffiliateQuickSummary.vue?vue&type=script&lang=js&"
export * from "./AffiliateQuickSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports